import { NavigationContainerRef } from "@react-navigation/native";
// IMPORTANT: re-export the SAME navigationRef that is attached to the
// <NavigationContainer> in `src/navigations/index.tsx`. Previously this file
// created its own `createNavigationContainerRef()` which was never attached,
// so `getNavigationRef()` always returned null.
import { navigationRef } from "@navigations/utils/RootNavigation";

export { navigationRef };

export const getNavigationRef = (): NavigationContainerRef<any> | null => {
  return navigationRef.isReady() ? navigationRef : null;
};
